import template from './sw-cms-preview-text-three-column.html.twig';
import './sw-cms-preview-text-three-column.scss';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
